<div *ngIf="!stepDetails" class="flex items-center justify-between bg-blue-600 text-white rounded-t px-6 py-4">
    <h5 class="text-lg font-semibold mb-0">{{title}}</h5>
    <div class="flex gap-2">
        <button type="button"
            class="bg-yellow-500 hover:bg-yellow-600 text-gray-900 font-medium rounded px-4 py-2 transition"
            (click)="submitForm()">Save Draft</button>
        <button type="button" 
            class="bg-green-600 hover:bg-green-700 text-white font-medium rounded px-4 py-2 transition"
            (click)="finalSubmit()" *ngIf="challengeForm.valid ">
            Submit
        </button>
       
    </div>
</div>
<div class="bg-amber-50  overflow-hidden transition-all " [ngClass]="{'border-2 border-gray-300 duration-200 hover:shadow-md': !stepDetails}">
    <!-- Draft Proposals Section -->
    <div *ngIf="draftProposals && draftProposals.length > 0 && !stepDetails" class="mb-3">
        <div class="bg-blue-50 border-l-4 border-blue-400 p-4">
            <div (click)="isSectionOpen.draftProposals = !isSectionOpen.draftProposals"
                class="flex items-center justify-between cursor-pointer text-blue-800 hover:bg-blue-100/70 p-2 rounded transition-all duration-200">
                <div class="flex items-center">
                    <i class="pi pi-info-circle mr-2"></i>
                    <span>
                        <b>Draft Proposals Found:</b> Select a draft below to continue editing, or fill in the form to
                        create a new proposal.
                    </span>
                </div>
                <i class="pi transition-transform duration-200"
                    [ngClass]="isSectionOpen.draftProposals ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
            </div>
            <div *ngIf="isSectionOpen.draftProposals" class="p-3 animate-fade-in">
                <app-data-table [data]="draftProposals" [title]="'Draft Proposals'" [url]="'/idex/save-draft/proposal/'"
                    [isEditable]="true" [showAddButton]="false"
                    (editEventRow)="populateDraftProposal($event); isSectionOpen.draftProposals = false"
                    [columns]="draftProposalColumns">
                </app-data-table>
            </div>
        </div>
    </div>
    <form [formGroup]="challengeForm" class="proposal-form-container px-6 py-2" >
        <!-- Header Section -->
        <div *ngIf="categoryFormVisible.name || categoryFormVisible.scheme" class="bg-amber-50 border-2 border-gray-300 mb-6 rounded transition-all duration-200 hover:shadow-md">
            <div (click)="isSectionOpen.createNewProposal = !isSectionOpen.createNewProposal"
                    class="flex items-center justify-between p-2 cursor-pointer bg-gray-100/90 text-gray-700 hover:bg-blue-950 hover:text-white transition-all duration-200">
                <h3 class="text-lg font-semibold  flex items-center">
                    <span
                        class="w-8 h-8 rounded-lg bg-blue-100 text-blue-600 flex items-center justify-center mr-3 text-sm">
                        <i class="pi pi-building"></i>
                    </span>
                    {{title}}
                </h3>
                <i class="pi transition-transform duration-200"
                    [ngClass]="isSectionOpen.createNewProposal ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
            </div>
            <div *ngIf="isSectionOpen.createNewProposal"
                class="p-3 space-y-4 border-t border-slate-100 animate-fade-in">
                <div class="mb-4 flex items-center " *ngIf="categoryFormVisible.name !== false">
                    <label for="name" class="block font-medium text-slate-700 mb-2 w-1/3 ">
                        Challenge Name
                        <ng-container *ngIf="challengeForm.get('name')?.errors?.['required'] || challengeForm.get('name')?.hasValidator(requiredValidator)">
                            <span class="text-red-500">*</span>
                        </ng-container>
                    </label>
                    <input pInputText id="name" formControlName="name" autocomplete="off"
                        class="w-2/3 px-2.5 py-2.5 border-2 border-slate-500  focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all" />
                </div>
                <div class="mb-2 flex items-center" *ngIf="categoryFormVisible.scheme !== false">
                    <label for="scheme" class="block font-medium text-slate-700 mb-2 w-1/3">
                        Scheme
                        <ng-container *ngIf="challengeForm.get('scheme')?.errors?.['required'] || challengeForm.get('scheme')?.hasValidator(requiredValidator)">
                            <span class="text-red-500">*</span>
                        </ng-container>
                    </label>
                    <div class="w-2/3">
                        <p-dropdown inputId="scheme" [options]="schemes" formControlName="scheme" optionLabel="name"
                            optionValue="id" placeholder="Scheme" [filter]="true" filterBy="name" appendTo="body"
                            [style]="{ width: '100%' }" [readonly]="true"
                            styleClass="w-full [&_.p-dropdown]:w-full [&_.p-dropdown]:border-slate-300 [&_.p-dropdown]:rounded"></p-dropdown>
                    </div>
                </div>
            </div>
        </div>

        <!-- Nodal & Coordinating Agency (expansion panel style) -->
        <div *ngIf="categoryFormVisible.category || categoryFormVisible.organisation || categoryFormVisible.nodal_precurement || categoryFormVisible.coordinated_agency_id || categoryFormVisible.nodal_officer_id || categoryFormVisible.release_date || categoryFormVisible.technology_domain" class="bg-amber-50 border-2 border-gray-300 mb-6 rounded transition-all duration-200 hover:shadow-md">
            <div (click)="isSectionOpen.basicInfo = !isSectionOpen.basicInfo"
                class="flex items-center justify-between p-2 cursor-pointer bg-gray-100/90 text-gray-700 hover:bg-blue-950 hover:text-white transition-all duration-200">
                <h3 class="text-lg font-semibold  flex items-center">
                    <span
                        class="w-8 h-8 rounded-lg bg-blue-100 text-blue-600 flex items-center justify-center mr-3 text-sm">
                        <i class="pi pi-building"></i>
                    </span>
                    Nodal & Coordinating Agency
                </h3>
                <i class="pi transition-transform duration-200"
                    [ngClass]="isSectionOpen.basicInfo ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
            </div>
            <div *ngIf="isSectionOpen.basicInfo" class="p-3 space-y-4 border-t border-slate-100 animate-fade-in">

                <div class="flex items-center" *ngIf="categoryFormVisible.category !== false">
                    <label class="block font-medium text-slate-700 mb-2 w-1/3">
                        Category
                        <ng-container *ngIf="challengeForm.get('category')?.errors?.['required'] || challengeForm.get('category')?.hasValidator(requiredValidator)">
                            <span class="text-red-500">*</span>
                        </ng-container>
                    </label>
                    <div class="w-2/3">
                        <p-dropdown [options]="categoryOptions"(onChange)="onCategoryChange($event)" formControlName="category" optionLabel="label"
                            optionValue="value" placeholder="-- Select Category --"
                            styleClass="w-full [&_.p-dropdown]:w-full [&_.p-dropdown]:border-slate-300 [&_.p-dropdown]:rounded"
                            [style]="{ width: '100%' }">
                        </p-dropdown>
                    </div>
                </div>
                <div class="flex items-center" *ngIf="categoryFormVisible.organisation !== false">
                    <label for="organisation" class="block font-medium text-slate-700 mb-2 w-1/3">
                        Moniteering organisation
                        <ng-container *ngIf="challengeForm.get('organisation')?.errors?.['required'] || challengeForm.get('organisation')?.hasValidator(requiredValidator)">
                            <span class="text-red-500">*</span>
                        </ng-container>
                    </label>
                    <div class="w-2/3">
                        <p-dropdown 
                            id="organisation"
                            [options]="unitList"
                            formControlName="organisation"
                            optionLabel="name"
                            optionValue="id"
                            [readonly]="true"
                            placeholder="Select Organisation"
                            appendTo="body"
                            styleClass="w-full [&_.p-dropdown]:w-full [&_.p-dropdown]:border-slate-300 [&_.p-dropdown]:rounded">
                        </p-dropdown>
                    </div>
                </div>
                <div class="flex items-center" *ngIf="categoryFormVisible.nodal_precurement !== false">
                    <label class="block font-medium text-slate-700 mb-2 w-1/3">
                        Nodal Directorate/Agency (For procurement)  
                        <ng-container *ngIf="challengeForm.get('nodal_precurement')?.errors?.['required']">
                            <span class="text-red-500">*</span>
                        </ng-container>
                    </label>
                    <div class="w-2/3">
                        <p-dropdown [options]="unitList" formControlName="nodal_precurement" optionValue="id"
                            optionLabel="name" placeholder="Select a Directorate"
                            styleClass="w-full [&_.p-dropdown]:w-full [&_.p-dropdown]:border-slate-300 [&_.p-dropdown]:rounded"
                            [style]="{ width: '100%' }" [filter]="true"
                            filterBy="name" appendTo="body">
                        </p-dropdown>
                    </div>
                </div>
                <div class="flex items-center" *ngIf="categoryFormVisible.coordinated_agency_id !== false">
                    <label class="block font-medium text-slate-700 mb-2 w-1/3">
                        Nodal Directorate/Agency (For Development & Trial)
                        <ng-container *ngIf="challengeForm.get('coordinated_agency_id')?.errors?.['required']">
                            <span class="text-red-500">*</span>
                        </ng-container>
                    </label>
                    <div class="w-2/3">
                        <p-dropdown [options]="unitList" formControlName="coordinated_agency_id" optionValue="id"
                            optionLabel="name" placeholder="Select a Directorate"
                            styleClass="w-full [&_.p-dropdown]:w-full [&_.p-dropdown]:border-slate-300 [&_.p-dropdown]:rounded"
                            [style]="{ width: '100%' }" (onChange)="onUnitChange($event)" [filter]="true"
                            filterBy="name" appendTo="body">
                        </p-dropdown>
                    </div>
                </div>
                <div class="flex items-center" *ngIf="categoryFormVisible.nodal_officer_id !== false">
                    <label class="block font-medium text-slate-700 mb-2 w-1/3">
                        Nodal Officer (For Development & Trial)
                        <ng-container *ngIf="challengeForm.get('nodal_officer_id')?.errors?.['required'] || challengeForm.get('nodal_officer_id')?.hasValidator(requiredValidator)">
                            <span class="text-red-500">*</span>
                        </ng-container>
                    </label>
                    <div class="w-2/3">
                        <p-dropdown id="userSelect" [options]="userList" optionLabel="first_name" [filter]="true"
                            filterBy="first_name,last_name,hrcdf_designation,loginname,unit.name"
                            formControlName="nodal_officer_id" placeholder="Choose a nodal officer" appendTo="body"
                            styleClass="w-full [&_.p-dropdown]:w-full [&_.p-dropdown]:border-slate-300 [&_.p-dropdown]:rounded">
                            <ng-template pTemplate="selectedItem" let-user>
                                <div *ngIf="user">
                                    <small>
                                        #<strong>{{ user.loginname }}</strong> |
                                        <strong>{{ user.first_name }} {{ user.last_name }}</strong>
                                    </small>
                                </div>
                                <div *ngIf="!user" class="dropdown-placeholder">
                                    Choose a user
                                </div>
                            </ng-template>
                            <!-- Dropdown list items -->
                            <ng-template pTemplate="item" let-user>
                                <div class="list-group-item list-group-item-action">
                                    <small>
                                        #<strong>{{ user.loginname }}</strong> |
                                        <strong>{{ user.first_name }} {{ user.last_name }}</strong> | <strong>{{
                                            user.hrcdf_designation }}</strong>
                                    </small>
                                </div>
                            </ng-template>
                        </p-dropdown>
                    </div>
                </div>
                <div class="flex items-center" *ngIf="categoryFormVisible.release_date !== false">
                    <div class="w-1/3">
                        <label for="release_date" class="block font-medium text-slate-700 mb-2">
                            Release Date (APSO Approval Date)
                            
                        </label>
                        <p class="text-xs text-red-600 italic mt-1">
                            This field will be automatically populated when APSO approval is received.
                        </p>
                    </div>
                    <input pInputText  type="date" readonly formControlName="release_date"
                        class="w-2/3 px-2.5 py-2.5 border-2 border-slate-500  focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                        [readonly]="true"
                         />
                </div>
                <div class="flex items-center" *ngIf="categoryFormVisible.technology_domain !== false">
                    <label for="technology_domain" class="block font-medium text-slate-700 mb-2 w-1/3">
                        Technology Domain
                        <ng-container *ngIf="challengeForm.get('technology_domain')?.errors?.['required'] || challengeForm.get('technology_domain')?.hasValidator(requiredValidator)">
                            <span class="text-red-500">*</span>
                        </ng-container>
                    </label>
                    <!-- <input pInputText id="technology_domain" type="text" 
                    class="w-2/3 px-2.5 py-2.5 border-2 border-slate-500  focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                    formControlName="technology_domain" /> -->
                    <div class="w-2/3">
                            <p-dropdown [options]="technologyDomainOptions" formControlName="technology_domain" optionValue="name"
                                optionLabel="name" placeholder="Select Technology Domain"
                                styleClass="w-full [&_.p-dropdown]:w-full [&_.p-dropdown]:border-slate-300 [&_.p-dropdown]:rounded"
                                [style]="{ width: '100%' }" [filter]="true"
                                filterBy="name" appendTo="body">
                            </p-dropdown>
                    </div>
                </div>
            </div>
        </div>

        <!-- Problem Statement (expansion panel style) -->
        <div *ngIf="categoryFormVisible.problem_statement" class="bg-amber-50 border-2 border-gray-300 mb-6 rounded transition-all duration-200 hover:shadow-md">
            <div (click)="isSectionOpen.problemStatement = !isSectionOpen.problemStatement"
                class="flex items-center justify-between p-2 cursor-pointer bg-gray-100/90 text-gray-700 hover:bg-blue-950 hover:text-white transition-all duration-200">
                <h3 class="text-lg font-semibold  flex items-center">
                    <span
                        class="w-8 h-8 rounded-lg bg-purple-100 text-purple-600 flex items-center justify-center mr-3 text-sm">
                        <i class="pi pi-comments"></i>
                    </span>
                    Problem Statement
                </h3>
                <i class="pi transition-transform duration-200"
                    [ngClass]="isSectionOpen.problemStatement ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
            </div>
                <div *ngIf="isSectionOpen.problemStatement" class="p-3 space-y-4 border-t border-slate-100 animate-fade-in">
                <div *ngIf="categoryFormVisible.problem_statement !== false">
                    <p class="block bg-blue-500 text-white font-medium text-slate-700 p-2">
                        Problem Statement
                        <ng-container *ngIf="challengeForm.get('problem_statement')?.errors?.['required'] || challengeForm.get('problem_statement')?.hasValidator(requiredValidator)">
                            <span class="text-yellow-500">*</span>
                        </ng-container>
                    </p>
                    <editor [init]="init" formControlName="problem_statement"></editor>
                </div>
            </div>
        </div>

        <!-- Detailed Information (expansion panel style) -->
        <div *ngIf="categoryFormVisible.challenge_brief || categoryFormVisible.prototype_development || categoryFormVisible.requirement || categoryFormVisible.ip_value || categoryFormVisible.functional_advantages || categoryFormVisible.domestic || categoryFormVisible.substitution || categoryFormVisible.preliminary_scope || categoryFormVisible.competitive_solution || categoryFormVisible.potential_market || categoryFormVisible.risk_assessment || categoryFormVisible.mpo_qty" class="bg-amber-50 border-2 border-gray-300 mb-6 rounded transition-all duration-200 hover:shadow-md">
            <div (click)="isSectionOpen.detailedInformation = !isSectionOpen.detailedInformation"
                class="flex items-center justify-between p-2 cursor-pointer bg-gray-100/90 text-gray-700 hover:bg-blue-950 hover:text-white transition-all duration-200">
                <h3 class="text-lg font-semibold  flex items-center">
                    <span
                        class="w-8 h-8 rounded-lg bg-yellow-100 text-yellow-600 flex items-center justify-center mr-3 text-sm">
                        <i class="pi pi-file"></i>
                    </span>
                    Detailed Information
                </h3>
                <i class="pi transition-transform duration-200"
                    [ngClass]="isSectionOpen.detailedInformation ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
            </div>
            <div *ngIf="isSectionOpen.detailedInformation"
                class="p-3   space-y-4 border-t border-slate-100 animate-fade-in">

                <div *ngIf="categoryFormVisible.challenge_brief !== false">
                    <p class="block bg-blue-500 text-white font-medium text-slate-700 p-2">
                        Challenge Brief/ Definition
                        <ng-container *ngIf="challengeForm.get('challenge_brief')?.errors?.['required'] || challengeForm.get('challenge_brief')?.hasValidator(requiredValidator)">
                            <span class="text-yellow-500">*</span>
                        </ng-container>
                    </p>
                    <editor [init]="init" formControlName="challenge_brief"></editor>
                </div>
                <div *ngIf="categoryFormVisible.prototype_development !== false">
                    <p class="block bg-blue-500 text-white font-medium text-slate-700 p-2">
                        Future Expectation from the prototype development
                        <ng-container *ngIf="challengeForm.get('prototype_development')?.errors?.['required'] || challengeForm.get('prototype_development')?.hasValidator(requiredValidator)">
                            <span class="text-yellow-500">*</span>
                        </ng-container>
                    </p>
                    <editor [init]="init" formControlName="prototype_development"></editor>
                </div>
                <div *ngIf="categoryFormVisible.requirement !== false">
                    <p class="block bg-blue-500 text-white font-medium text-slate-700 p-2">
                        Need / Requirement of the proposed challenge
                        <ng-container *ngIf="challengeForm.get('requirement')?.errors?.['required'] || challengeForm.get('requirement')?.hasValidator(requiredValidator)">
                            <span class="text-yellow-500">*</span>
                        </ng-container>
                    </p>
                    <editor [init]="getPlaceValue(`Need is - High / Moderate / Low\n\n(Need of the proposed challenge; limitations / unavailability of the existing solutions; Any other relevant info)`)"  formControlName="requirement"></editor>
                </div>
                <div *ngIf="categoryFormVisible.ip_value !== false">
                    <p class="block bg-blue-500 text-white font-medium text-slate-700 p-2">
                        IP Value
                        <ng-container *ngIf="challengeForm.get('ip_value')?.errors?.['required'] || challengeForm.get('ip_value')?.hasValidator(requiredValidator)">
                            <span class="text-yellow-500">*</span>
                        </ng-container>
                    </p>
                    <editor [init]="getInitValue(`IP Valuation Criteria Value < 60 Cr - Low   Value 60 - 120 Cr - Moderate   Value > 120 Cr - High   IP Valuation will be provided by iDEX-DIO.`)" formControlName="ip_value"></editor>
                
                </div>
                <div *ngIf="categoryFormVisible.functional_advantages !== false">
                    <p class="block bg-blue-500 text-white font-medium text-slate-700 p-2">
                        Functional Advantages
                        <ng-container *ngIf="challengeForm.get('functional_advantages')?.errors?.['required'] || challengeForm.get('functional_advantages')?.hasValidator(requiredValidator)">
                            <span class="text-yellow-500">*</span>
                        </ng-container>
                    </p>
                    <!-- <editor [init]="init" formControlName="functional_advantages"></editor> -->
                     <editor [init]="getFunctionalValue(`Importance of Intended product (High/Moderate/Low) for the operations of the services / Indian Navy. (Elaborate – if any)`)" formControlName="functional_advantages">
                     </editor>
                </div>
                <div *ngIf="categoryFormVisible.domestic !== false">
                    <p class="block bg-blue-500 text-white font-medium text-slate-700 p-2">
                        Domestic Development Capability
                        <ng-container *ngIf="challengeForm.get('domestic')?.errors?.['required'] || challengeForm.get('domestic')?.hasValidator(requiredValidator)">
                            <span class="text-yellow-500">*</span>
                        </ng-container>
                    </p>
                    <!-- <editor [init]="init" formControlName="domestic"></editor> -->
                     <editor [init]="getDomesticValue(`Unique Domestic Capability Development If no equivalent solution available domestically: High Less efficient solution available domestically: Moderate Similar / Equivalent Solution available domestically: Low `)" formControlName="domestic">
                     </editor>
                </div>
                <div *ngIf="categoryFormVisible.substitution !== false">
                    <p class="block bg-blue-500 text-white font-medium text-slate-700 p-2">
                        Import Substitution (Reliability & Flexibility of existing source of import)
                        <ng-container *ngIf="challengeForm.get('substitution')?.errors?.['required'] || challengeForm.get('substitution')?.hasValidator(requiredValidator)">
                            <span class="text-yellow-500">*</span>
                        </ng-container>
                    </p>
                    <!-- <editor [init]="init" formControlName="substitution"> -->
                     <editor [init]="getImportValue(`Reliability and Flexibility of Existing Source of Import. Has existing source of Import defaulted previously in any defence contract or who have imposed sanctions embargo against India or have denied supply of certain technologies or have controlled exports from their country citing regulations - Yes/No/NA. Has existing source of Import delayed or refused integration of domestic equipment  weapons with their systems - Yes/No/NA. Has existing source of import denied  refused to supply spares stating stoppage of production or unwillingness of their vendors to supply in the past - Yes/No/NA.`)" formControlName="substitution">

                    </editor>
                </div>
                <div *ngIf="categoryFormVisible.preliminary_scope !== false">
                    <p class="block bg-blue-500 text-white font-medium text-slate-700 p-2">
                        Preliminary scope of solution being developed
                        <ng-container *ngIf="challengeForm.get('preliminary_scope')?.errors?.['required'] || challengeForm.get('preliminary_scope')?.hasValidator(requiredValidator)">
                            <span class="text-yellow-500">*</span>
                        </ng-container>
                    </p>
                    <editor [init]="getPreliminaryValue(`Summary of PDS/PRU.  Any other relevant info`)" formControlName="preliminary_scope"></editor>
                </div>
                <div *ngIf="categoryFormVisible.competitive_solution !== false">
                    <p class="block bg-blue-500 text-white font-medium text-slate-700 p-2">
                        Global competitive nature of the problem including novelty of the solution
                        (from user perspective)
                        <ng-container *ngIf="challengeForm.get('competitive_solution')?.errors?.['required'] || challengeForm.get('competitive_solution')?.hasValidator(requiredValidator)">
                            <span class="text-yellow-500">*</span>
                        </ng-container>
                    </p>
                    <editor [init]="getGlobalValue(`Unique Domestic Capability Development (High/Moderate/Low)  If no equivalent solution available domestically: High.  Less efficient solution available domestically: Moderate. Similar / Equivalent solution available domestically: Low. (Is there any need of domestic capability development & Elaboration – if any)`)" formControlName="competitive_solution"></editor>
                </div>
                <div *ngIf="categoryFormVisible.potential_market !== false">
                    <p class="block bg-blue-500 text-white  font-medium text-slate-700 p-2">
                        Potential market for product/technology (from user perspective)
                        <ng-container *ngIf="challengeForm.get('potential_market')?.errors?.['required'] || challengeForm.get('potential_market')?.hasValidator(requiredValidator)">
                            <span class="text-yellow-500">*</span>
                        </ng-container>
                    </p>
                    <editor [init]="getPotentialValue(`1. Present and future requirement of the products in Service (from Procurement perspective).  2. Will the development product be able to strengthen the defence export of India?  3. Any other relevant info.`)" formControlName="potential_market"></editor>
                </div>
                <div *ngIf="categoryFormVisible.risk_assessment !== false">
                    <p class="block bg-blue-500 text-white  font-medium text-slate-700 p-2">
                        Risk Assessment
                        <ng-container *ngIf="challengeForm.get('risk_assessment')?.errors?.['required'] || challengeForm.get('risk_assessment')?.hasValidator(requiredValidator)">
                            <span class="text-yellow-500">*</span>
                        </ng-container>
                    </p>
                    <editor [init]="getRiskValue(`1. Any critical risk parameters / dependability which may cause a failure?  2. Any other relevant info.`)" formControlName="risk_assessment"></editor>
                </div>
                <div *ngIf="categoryFormVisible.mpo_qty !== false">
                    <p class="block bg-blue-500 text-white  font-medium text-slate-700 p-2">
                        Pilot Procurement Plan with Minimum Pilot Order Quantity(MPQ)
                        <ng-container *ngIf="challengeForm.get('mpo_qty')?.errors?.['required'] || challengeForm.get('mpo_qty')?.hasValidator(requiredValidator)">
                            <span class="text-yellow-500">*</span>
                        </ng-container>
                    </p>
                    <editor [init]="getPilotValue(`Minimum 01 Qty`)" formControlName="mpo_qty"></editor>
                </div>
            </div>
        </div>

        <!-- Document Uploads (expansion panel style) -->
        <div class="bg-amber-50 border-2 border-gray-300 mb-3 rounded transition-all duration-200 hover:shadow-md">
            <div (click)="isSectionOpen.documentUploads = !isSectionOpen.documentUploads"
                class="flex items-center justify-between p-2 cursor-pointer bg-gray-100/90 text-gray-700 hover:bg-blue-950 hover:text-white transition-all duration-200">
                <h3 class="text-lg font-semibold  flex items-center">
                    <span
                        class="w-8 h-8 rounded-lg bg-green-100 text-green-600 flex items-center justify-center mr-3 text-sm">
                        <i class="pi pi-paperclip"></i>
                    </span>
                    Document Uploads (PDS, PRU, & Additional Documents)
                </h3>
                <i class="pi transition-transform duration-200"
                    [ngClass]="isSectionOpen.documentUploads ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
            </div>
            <div *ngIf="isSectionOpen.documentUploads" class="p-3 space-y-4 border-t border-slate-100 animate-fade-in">
                <app-upload-document #uploadDoc *ngIf="!stepDetails ;else otherSteps" [isEditable]="true" [dmsFiles]="selectedDraftProposal?.dms_files|| files || []"   [isSaveVied]="true" (uploadData)="onDocumentUpload($event)"> </app-upload-document>
                <ng-template #otherSteps>
                    <app-upload-document [isEditable]="stepDetails.can_edit" [proposal_step]="idexfristStepData.id"  > </app-upload-document>
                </ng-template>
            </div>
    </div>
</form>
  
</div>
<p-toast></p-toast>